// index.js
import { default as savedSearchReducer } from './reducers';
export { default as savedSearchOperations } from './operations';
export { default as savedSearchTypes } from './types';
export default savedSearchReducer;